import { combineReducers } from 'redux';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import reduce from 'lodash/reduce';
import sum from 'lodash/sum';
import moment from 'moment';
import config from '../../../../config';
import * as types from '../constants';

const makeDetails = (rows) => {
  return groupBy(rows, (row) => {
    return moment(row.fromDate).format(config.dateFormatISO);
  });
};

export const makeSummary = (rows) => {
  const details = makeDetails(rows);

  return map(details, (byDate) => {
    return reduce(
      byDate,
      (result, row) => {
        const updates = {};

        if (row.transferredToBarber) {
          updates.barberAmount =
            result.barberAmount +
            sum([row.servicesRevenue, row.productsRevenue, row.servicesInstantPayoutFee, row.productsInstantPayoutFee]);

          updates.barberDeposited = result.barberDeposited + sum([row.servicesRevenue, row.productsRevenue]);
        }

        if (row.barberId || row.unassigned) {
          updates.shopAmount =
            result.shopAmount +
            sum([row.productsDueToShop, row.servicesDueToShop, row.totalProductsTaxAmount, row.totalServicesTaxAmount]);
        }

        if (!result.transferDate) {
          updates.transferDate = row.createdAt;
          updates.fromDate = row.fromDate;
          updates.toDate = row.toDate;
        }

        if (row.tips) {
          updates.tipsDeposited = result.tipsDeposited + row.tips.totalDeposited;
        }

        return { ...result, ...updates };
      },
      {
        transferDate: null,
        fromDate: null,
        toDate: null,
        shopAmount: 0,
        barberAmount: 0,
        tipsDeposited: 0,
        barberDeposited: 0,
      }
    );
  });
};

// New reducer for raw data and pagination
const rawData = (state = [], { type, payload }) => {
  switch (type) {
    case types.FETCH_PAYOUT_HISTORY:
      return payload;
    case types.APPEND_PAYOUT_HISTORY:
      return [...state, ...payload];
    default:
      return state;
  }
};

const pagination = (state = { skip: 0, hasMore: true }, { type, payload }) => {
  switch (type) {
    case types.FETCH_PAYOUT_HISTORY:
      return { skip: payload.length, hasMore: payload.length > 0 };
    case types.APPEND_PAYOUT_HISTORY:
      return { skip: state.skip + payload.length, hasMore: payload.length > 0 };
    default:
      return state;
  }
};

export default combineReducers({
  rawData,
  pagination,
});
